import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      "html, body, #root": {
        margin: 0,
        padding: 0,
        minHeight: "100%",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        WebkitTextSizeAdjust: "100%",
      },
      body: {
        bg: "gray.50",
      },
    },
  },
  fonts: {
    body: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    heading: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },
});

export default theme;
